
import { defineComponent } from "vue";
import { VaultSummary, VaultTabs } from "@/components/vault";

export default defineComponent({
  name: "vault-management",
  components: {
    VaultSummary,
    VaultTabs,
  },
});
